import $ from 'jquery';
import mediator from './mediator';

const configureHeroBG = () => {
  const screenSize = window.cigna.screen.breakpoint;
  $('.hero-white-left-box').removeClass('d-none');
  switch (screenSize) {
    case 'xs':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-xs-bg')})`, height: '144px' });
      $('.hero-long-intro').css('background-size', `100% calc(${$('.long-intro-content').outerHeight(true)}px + ${$('.long-intro-accent').outerHeight(true)}px + 184px + 1.5rem)`);
      $('.hero-white-left-box').css({ left: '0px' });
      $('.hero-full-width-photo').css('margin-bottom', '3rem');
      break;
    case 'sm':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-sm-bg')})`, height: '192px' });
      $('.hero-long-intro').css('background-size', `100% calc(${$('.long-intro-content').outerHeight(true)}px + ${$('.long-intro-accent').outerHeight(true)}px + 284px + 3rem)`);
      $('.hero-white-left-box').css({ left: '0px' });
      $('.hero-full-width-photo').css('margin-bottom', '3rem');
      break;
    case 'md':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-md-bg')})`, height: '248px' });
      $('.hero-white-left-box').css({ left: 'calc((100% - 724px + 2rem) / 2)' });
      $('.hero-full-width-photo').css('margin-bottom', `calc((${$('.hero-white-left-box').outerHeight(true)}px - (248px - 2rem)) + 4rem)`);
      break;
    case 'lg':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-lg-bg')})`, height: '284px' });
      $('.hero-white-left-box').css({ left: 'calc((100% - 964px + 2rem) / 2)' });
      $('.hero-white-left-box').css('max-width', 'calc((100% - (100% - 1144px + 1rem)) * .4166)');
      $('.hero-full-width-photo').css('margin-bottom', `calc((${$('.hero-white-left-box').outerHeight(true)}px - (284px - 2rem)) + 4rem)`);
      break;
    case 'xl':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-lg-bg')})`, height: '360px' });
      $('.hero-white-left-box').css({ left: 'calc((100% - 1144px + 2rem) / 2)' });
      $('.hero-white-left-box').css('max-width', 'calc((100% - (100% - 1144px + 1rem)) * .4166)');
      $('.hero-full-width-photo').css('margin-bottom', `calc((${$('.hero-white-left-box').outerHeight(true)}px - (360px - 3rem)) + 4.5rem)`);
      break;
    default:
      break;
  }
};

export const initialHeroBG = () => {
  const screenSize = window.cigna.screen.breakpoint;
  switch (screenSize) {
    case 'xs':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-xs-bg')})`, height: '144px' });
      break;
    case 'sm':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-sm-bg')})`, height: '192px' });
      break;
    case 'md':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-md-bg')})`, height: '248px' });
      break;
    case 'lg':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-lg-bg')})`, height: '284px' });
      break;
    case 'xl':
      $('.hero-bg').css({ 'background-image': `url(${$('.hero-bg').attr('data-lg-bg')})`, height: '360px' });
      break;
    default:
      break;
  }
  $('.hero').ready(configureHeroBG);
  mediator.on('window:throttledResize', configureHeroBG);
};

export default () => {
  initialHeroBG();
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/heroes.js